
import React from 'react'
import Breadcrumb from '../../Shared/BreadCumb';
import { DATA_CHART_MAIN } from '../../Shared/Constants';
import Chart from "react-apexcharts";
import { getOfficials } from './services/officials';
import ClipLoader from "react-spinners/ClipLoader";
import { getAllPenalities } from '../penalities/services/penalities';
import ResponsiveTable from '../../Shared/ResponsiveTable';
 
class DetailOfficer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: [
                { name: 'Detalles', href: '#', current: true, id:0 },
                { name: 'Historial de Multas', href: '#', current: false, id:1 },
                // { name: 'Metricas', href: '#', current: false, id:2 }
            ],
            items: [],
            numberPerMonth:[0,0,0,0,0,0,0,0,0,0,0,0],
            loading:false,
            official: null,
            penalities:[]
        }
    }

    BreadcrumbPages = [
        { name: 'Administración', href: '#', current: false },
        { name: 'Lista de Funcionarios', href: '#', current: false },
        { name: 'Detalles', href: '#', current: true },
    ]

    columns = [
        {field:'dateReg', headerName: 'Fecha de registro', width:150 },
        {field:'sectorDescrip', headerName: 'Sector', width:150}, 
        {field:'typeFineDescrip', headerName: 'Tipo', width:150}, 
        {field:'totalValue', headerName: 'Monto', width:150},
    ]

    componentDidMount() {
        const id = window.location.href.split('/')[window.location.href.split('/').length-1]
        this.setState({loading:true})
        const officials = getOfficials({id:0,idRange:0,identification:id,userName:"",search:"",limit:500})
        const penalities = getAllPenalities({idOfficial:0, officialIdentification:id, id:0, identification:'', search:'', numberPlate:'', limit:500})
        Promise.all([officials, penalities]).then((values)=>{
            this.setState({official:values[0].data.data[0]})
            if(values[1].status === 200) {
                const penalities = [];
                values[1].data.data.forEach(element => {
                    if(element.headerFine) {
                        for(let i=0; i < element.headerFine.length; i++){
                            penalities.push(element.headerFine[i])
                        }
                    }
                });
                this.setState({penalities:penalities});
            }
            this.setPenalitiesByMonth()
            this.setState({loading:false});

        }).catch((error)=>{
            this.setState({loading:false})
        })
    }

    setPenalitiesByMonth = () => {
        const month_list = this.state.numberPerMonth;
        this.state.penalities.forEach((penalitie) => {
            const month = this.getMetricsByMonth(penalitie.dateReg);
            month_list[month-1] = month_list[month-1] + 1
        })
        this.setState({numberPerMonth:month_list});
    }

    classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    setTab = (tab) => {
        const tabs = this.state.tabs.map((t)=>{
                if(t.id === tab.id){
                    t.current = true
                }else{
                    t.current = false
                }
                return t
            });
        this.setState({tabs:tabs});
    }

    getMetricsByMonth = (month) =>{
        const dateObject = new Date(month);
        return dateObject.getMonth() + 1
    }

    renderBarChart = () => {
        const series = [{
                name: 'Multas',
                data: this.state.numberPerMonth
        }];
        return(
            <div>
                <div className="relative overflow-hidden rounded-lg bg-white px-4 pb-12 pt-5 shadow sm:px-4 sm:pt-4">
                    <h1 className="font-semibold text-gray-900">MULTAS REGISTRADAS POR EL AÑO 2025</h1>
                        <Chart
                            options={DATA_CHART_MAIN}
                            series={series}
                            type='area'
                            height={300}
                        />
                </div>
            </div>
        )
    }

    renderDetail = () => {
        return (
                <div style={{paddingLeft:50, paddingTop:20}}>
                    <div className="overflow-hidden bg-white shadow sm:rounded-lg">
                        <dl className="divide-y divide-gray-100" style={{padding:20}}>
                            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm/6 font-medium text-gray-900">Nombre</dt>
                                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{this.state.official?.firstName} {this.state.official?.middleName}</dd>
                            </div>
                            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm/6 font-medium text-gray-900">Apellido</dt>
                                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{this.state.official?.firstLastName} {this.state.official?.middleLastName}</dd>
                            </div>
                            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm/6 font-medium text-gray-900">Dirección de correo</dt>
                                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{this.state.official?.email}</dd>
                            </div>
                            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm/6 font-medium text-gray-900">Identificación</dt>
                                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{this.state.official?.identification}</dd>
                            </div>
                            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm/6 font-medium text-gray-900">Rango</dt>
                                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{this.state.official?.rangeDescrip}</dd> 
                            </div>
                            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm/6 font-medium text-gray-900">Dirección de residencia</dt>
                                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{this.state.official?.address}</dd>
                            </div>
                            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm/6 font-medium text-gray-900">Género</dt>
                                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{this.state.official?.gender}</dd>
                            </div>
                            <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm/6 font-medium text-gray-900">Numeros de Teléfono</dt>
                                <dd className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{this.state.official?.phone?.map((item) => {
                                    return(
                                        <div>
                                            {item}
                                            <br></br>
                                        </div>
                                    )
                                })}</dd>
                            </div>
                        </dl>
                    </div>
                </div>
        )
    }

    formatDate = (date) => {
        const fecha = new Date(date);
        const horas = fecha.getHours();
        const minutos = fecha.getMinutes();
        const ampm = horas >= 12 ? 'PM' : 'AM';
        const horaFormateada = horas % 12 || 12;
        return `${fecha.getFullYear()}-${(fecha.getMonth() + 1).toString().padStart(2, '0')}-${fecha.getDate()} ${horaFormateada}:${minutos.toString().padStart(2, '0')} ${ampm}`;
    } 

    renderHistoric = () => {
        return(
                <div className="px-4 sm:px-6 lg:px-8">
                    <ResponsiveTable columns={this.columns} data={this.state.penalities} />
                </div>
        )
    }



    render(){
          return (
            <div>
                <div style={{marginBottom:10}}>
                    <Breadcrumb pages={this.BreadcrumbPages}/>
                </div>
                <div className="sm:hidden">
                    {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
                    <select
                        id="tabs"
                        name="tabs"
                        value={this.state.tabs.find((tab) => tab.current)?.name || ''}
                        onChange={(e) => {
                            const selectedTab = this.state.tabs.find(tab => tab.name === e.target.value);
                            if (selectedTab) {
                                this.setTab(selectedTab);
                            }
                        }}
                        className="block w-full rounded-md border-gray-300 focus:border-indigo-950 focus:ring-indigo-950"
                    >
                    {this.state.tabs.map((tab) => (
                        <option key={tab.name} value={tab.name}>{tab.name}</option>
                    ))}
                    </select>
                </div>
                <div className="hidden sm:block">
                        <div className="border-b border-gray-200">
                            <nav aria-label="Tabs" className="-mb-px flex">
                                {this.state.tabs.map((tab) => (
                                    <button
                                        onClick={()=>this.setTab(tab)}
                                        key={tab.name}
                                        aria-current={tab.current ? 'page' : undefined}
                                        className={this.classNames(
                                        tab.current
                                            ? 'border-indigo-900 text-indigo-900'
                                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                        'flex-1 border-b-2 px-1 py-4 text-center text-sm font-medium',
                                        )}
                                    >
                                        {tab.name}
                                    </button>
                                ))}
                            </nav>
                        </div>
                    </div>
                {/*TABS CONTENT*/}
                {
                    this.state.loading ? 
                        <center>
                            <ClipLoader
                                color={'gray'}
                                loading={true}
                                size={50}
                                aria-label="Loading Spinner"
                                data-testid="loader"/>
                        </center> : 
                        <div>
                                {
                                    this.state.tabs[0].current ? this.renderDetail() : null
                                }
                                {
                                    this.state.tabs[1].current ? this.renderHistoric() : null
                                }
                                {   /*
                                        this.state.tabs[2].current ? this.renderBarChart() : null
                                    */
                                }
                        </div>
                }
            </div>
        )
    }
}

export default DetailOfficer;